import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import queryString from 'query-string';
import TableHeader from 'admin/components/shared/TableHeaders';
import TableRows from 'admin/components/shared/TableRows';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import { formatUUID, formatNum, formatDate } from 'admin/utils';
import { getKioskPlayDetail } from 'admin/actions/devices';
import styles from './styles.scss';

class KioskPlayDetail extends Component {

  constructor(props) {
    super(props);
    this.defaultPagination = { page: 1, per_page: 20 };
    this.params = queryString.parse(this.props.location.search);
  }

  componentDidMount() {
    this.fetchKioskPlayDetail();
  }

  fetchKioskPlayDetail() {
    this.props.getKioskPlayDetail(this.props.match.params.id);
  }

  rowLabelItem(label, item) {
    return (
      <div styleName="row">
        <div styleName="label">{label}</div>
        <div styleName="item">{item}</div>
      </div>
    );
  }

  render() {
    const detail = this.props.kioskPlayDetail;
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: '各種設定', href: '', active: true },
      { value: 'デバイス管理', href: '/settings/devices', active: false },
      { value: 'チャージ履歴', href: '/', active: true },
      { value: 'チャージ詳細', href: '/', active: true },
    ];
    const coinsColumns = [
      { label: '合計金額', align: 'center', size: 2 },
      { label: '1円', align: 'center', size: 1 },
      { label: '5円', align: 'center', size: 1 },
      { label: '10円', align: 'center', size: 1 },
      { label: '50円', align: 'center', size: 1 },
      { label: '100円', align: 'center', size: 1 },
      { label: '500円', align: 'center', size: 1 },
    ];
    const billsColumns = [
      { label: '合計金額', align: 'center', size: 2 },
      { label: '1000円', align: 'center', size: 1 },
      { label: '2000円', align: 'center', size: 1 },
      { label: '5000円', align: 'center', size: 1 },
      { label: '10000円', align: 'center', size: 1 },
    ];
    const totalColumns = [
      { label: '合計金額', align: 'center', size: 2 },
    ];
    const coinsRows = [[
      { data: `¥ ${formatNum(this.props.kioskPlayDetail.coins_amount)}`, align: 'center' },
      { data: detail.coin_1, align: 'center' },
      { data: detail.coin_5, align: 'center' },
      { data: detail.coin_10, align: 'center' },
      { data: detail.coin_50, align: 'center' },
      { data: detail.coin_100, align: 'center' },
      { data: detail.coin_500, align: 'center' },
    ]];
    const billsRows = [[
      { data: `¥ ${formatNum(this.props.kioskPlayDetail.bills_amount)}`, align: 'center' },
      { data: detail.bill_1000, align: 'center' },
      { data: detail.bill_2000, align: 'center' },
      { data: detail.bill_5000, align: 'center' },
      { data: detail.bill_10000, align: 'center' },
    ]];
    const totalRows = [[
      { data: `¥ ${formatNum(this.props.kioskPlayDetail.total_amount)}`, align: 'center' },
    ]];
    return (
      <div>
        <Breadcrumb items={crumb} />
        <div styleName="headline">基本情報</div>
        {this.rowLabelItem("チャージID", formatUUID(detail.cashtray_id))}
        {this.rowLabelItem("取引ID",
            <Link to={`/transactions/${detail.transaction_id}`}>
              {formatUUID(detail.transaction_id)}
            </Link>)}
        {this.rowLabelItem("支払ID", formatUUID(detail.check_id))}
        {this.rowLabelItem("取引状態", detail.status)}
        {this.rowLabelItem("端末名", this.params.terminal_name)}
        {this.rowLabelItem("Browser Location", detail.browser_location)}
        {this.rowLabelItem("作成日時", formatDate(detail.created_at))}
        {this.rowLabelItem("更新日時", formatDate(detail.updated_at))}

        <br />

        <div styleName="headline">各金種枚数/金額</div>
        <div styleName="label">硬貨</div>
        <div styleName="list-table">
          <TableHeader columns={coinsColumns} />
          <TableRows rows={coinsRows} columns={coinsColumns} />
        </div>
        <div styleName="label">紙幣</div>
        <div styleName="list-table">
          <TableHeader columns={billsColumns} />
          <TableRows rows={billsRows} columns={billsColumns} />
        </div>
        <div styleName="label">合計</div>
        <div styleName="list-table">
          <TableHeader columns={totalColumns} />
          <TableRows rows={totalRows} columns={totalColumns} />
        </div>
      </div>
    );
  }
}

KioskPlayDetail.defaultProps = {
  getKioskPlayDetail: PropTypes.func,
  kioskPlayDetail: {},
};

KioskPlayDetail.propTypes = {
  getKioskPlayDetail: PropTypes.func,
  kioskPlayDetail: PropTypes.shape({
    cashtray_id: PropTypes.string,
    transaction_id: PropTypes.string,
    check_id: PropTypes.string,
    status: PropTypes.string,
    coin_1: PropTypes.number,
    coin_5: PropTypes.number,
    coin_10: PropTypes.number,
    coin_50: PropTypes.number,
    coin_100: PropTypes.number,
    coin_500: PropTypes.number,
    coins_amount: PropTypes.number,
    bill_1000: PropTypes.number,
    bill_2000: PropTypes.number,
    bill_5000: PropTypes.number,
    bill_10000: PropTypes.number,
    bills_amount: PropTypes.number,
    total_amount: PropTypes.number,
    browser_location: PropTypes.string,
    created_at: PropTypes.string,
    updated_at: PropTypes.string,
  }),
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};


const mapStateToProps = state => ({
  kioskPlayDetail: state.device.kioskPlayDetail,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getKioskPlayDetail,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(KioskPlayDetail, styles));
